import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CommonDataModel } from '../common-data-model';
import { EmailGenerationFormComponent } from '../email-generation-form/email-generation-form.component';
import * as _ from 'lodash';
import { CommonService } from 'src/app-core/services/common.service';
import { finalize } from 'rxjs/operators';
import * as moment from 'moment';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-order-email-popup-form',
    templateUrl: './order-email-popup-form.component.html',
    styleUrls: ['./order-email-popup-form.component.scss']
})
export class OrderEmailPopupFormComponent implements OnInit {

    @ViewChild('emailComponent', { static: false }) emailComponent: EmailGenerationFormComponent;

    commonDataModel = new CommonDataModel();
    notificationOfArrivalForm = this.commonDataModel.notificationOfArrivalFormModel;
    statusUpdateModel = this.commonDataModel.ordersBulkStatusUpdateModel;
    isFormLoading = false;
    documentConfigs: any;
    emailData: any;
    orderId: string;
    emailForm = this.commonDataModel.emailFormModel;
    bolEmailDocumentData = this.commonDataModel.bolFormModel;
    statusList = [];
    isFvBolUrl: boolean = false;
    fvBolUrl: any

    constructor(
        private toastr: ToastrService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<OrderEmailPopupFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MatDialog,
        private commonService: CommonService
    ) {

    }

    ngOnInit() {
        this.emailData = this.data;
        this.isFvBolUrl = this.emailData.fvBolUrl ? true : false;
        this.fvBolUrl = this.emailData.fvBolUrl;
        this.documentConfigs = this.emailData.documentConfigData;
        this.orderId = this.emailData.orderId;
        this.getOrderStatus();
    }

    getOrderStatus() {
        let queryString = `IsJob=${this.emailData.orderDetails.isJob ? true : false}`;
        if (this.orderId) {
            queryString += `&OrderId=${this.emailData.orderDetails.id}`;
        }
        this.commonService.getOrderStatus(queryString).subscribe((response: any) => {
            this.statusList = response.data;
        });
    }

    onSubmit() {
        this.emailForm = this.emailComponent.emailForm;
        this.emailForm.orderId = this.emailData.orderDetails.id;
        const emailForm = _.cloneDeep(this.emailForm);
        emailForm.orderId = this.emailData.orderDetails.id;
        if (!this.emailComponent.isBol && !this.emailComponent.isFvBol) {
            return this.toastr.warning(CommonConstants.appComponent.selectAttachment);
        }
        if (!this.emailComponent.isEmailtoValid()) {
            return this.toEmailValidationMessage();
        }
        if (!this.emailComponent.isEmailccValid()) {
            return this.ccEmailValidationMessage();
        }
        if (!this.emailComponent.isEmailbccValid()) {
            return this.bccEmailValidationMessage();
        }
        this.setAdditionalEmails(emailForm, this.emailComponent);
        if (this.emailData.documentDetails) {
            emailForm.blobUrl = this.emailData.documentDetails.blobUrl;
            emailForm.fileName = `${this.emailData.documentDetails.name}.${this.emailData.documentDetails.type}`;
        }
        delete emailForm.bccToMyself;
        if (emailForm.to) {
            if (this.emailData.source && this.emailData.source === 'finalDims') {
                this.sendBOLEmailDocument(emailForm);
            } else if (this.emailData.source && this.emailData.source === 'overview') {
                this.sendEmailStatusChange(emailForm);
            } else {
                this.sendEmailDocument(emailForm);
            }

        } else {
            this.toastr.warning(CommonConstants.appComponent.toEmailRequired);
        }
    }

    sendBOLEmailDocument(emailForm: any) {
        this.bolEmailDocumentData.orderId = this.emailData.orderId;
        this.bolEmailDocumentData.isSendEmail = true;
        this.bolEmailDocumentData.emailDetails.to = emailForm.to;
        this.bolEmailDocumentData.emailDetails.cc = this.emailForm.cc;
        this.bolEmailDocumentData.emailDetails.bcc = this.emailForm.bcc;
        this.bolEmailDocumentData.emailDetails.subject = this.emailForm.subject;
        this.bolEmailDocumentData.emailDetails.body = this.emailForm.body;
        this.bolEmailDocumentData.emailDetails.orderId = this.emailForm.orderId;
        this.isFormLoading = true;
        this.bolEmailDocumentData.isFv = this.emailData.isFv;
        this.bolEmailDocumentData.isBol = this.emailComponent.isBol;
        this.bolEmailDocumentData.isFvBol = this.emailComponent.isFvBol;
        this.bolEmailDocumentData.fvBolUrl = this.emailData.bolUrl;
        this.commonService.bolPublishDocument(this.bolEmailDocumentData)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    const sendingData = {
                        confirmResult: true
                    };
                    this.dialogRef.close(sendingData);
                } else {
                    this.toastr.error(response.errors || CommonConstants.errorMessageConstants.errorMessageRetry, CommonConstants.appComponent.error);
                }
            });
    }

    sendEmailStatusChange(emailForm: any) {
        this.notificationOfArrivalForm.orderId = this.emailData.orderId;
        this.notificationOfArrivalForm.isSendEmail = true;
        this.notificationOfArrivalForm.emailDetails.to = emailForm.to;
        this.notificationOfArrivalForm.emailDetails.cc = this.emailForm.cc;
        this.notificationOfArrivalForm.emailDetails.bcc = this.emailForm.bcc;
        this.notificationOfArrivalForm.emailDetails.subject = this.emailForm.subject;
        this.notificationOfArrivalForm.emailDetails.body = this.emailForm.body;
        this.bolEmailDocumentData.emailDetails.orderId = this.emailForm.orderId;
        this.isFormLoading = true;
        this.commonService.notificationOfArrivalDocument(this.notificationOfArrivalForm)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    const sendingData = {
                        confirmResult: true
                    };
                    this.dialogRef.close(sendingData);
                } else {
                    this.toastr.error(response.errors || CommonConstants.errorMessageConstants.errorMessageRetry, CommonConstants.appComponent.error);
                }
            });
    }

    sendEmailDocument(emailForm: any) {
        if (this.emailData.orderDetails.statusId === 1 &&
            !this.emailData.orderDetails.isJob && !this.emailData.orderDetails.isQuickQuote) {
            this.statusUpdateModel.isLocked = true;
            this.statusUpdateModel.orderId = [this.emailData.orderDetails.orderId];
            this.statusUpdateModel.statusId = 2;
            this.statusUpdateModel.statusName = this.statusList.find(item => item.id === 2).name;
            this.statusUpdateModel.serviceDate = moment().format();
            this.statusUpdateModel.serviceTime = moment(this.statusUpdateModel.serviceDate).format('HH:mm:ss');
            this.statusUpdateModel.notes = '';
            this.isFormLoading = true;
            this.commonService.orderBulkUpdate(this.statusUpdateModel).subscribe((response: any) => {
                if (response.isSuccess) {
                    // this.toastr.success('Status update successfully');
                    this.sendEmailDocumentContinue(emailForm);
                } else {
                    this.toastr.error(response.errors || CommonConstants.errorMessageConstants.errorMessageRetry, CommonConstants.appComponent.error);
                }
            });
        } else {
            this.sendEmailDocumentContinue(emailForm);
        }
    }

    sendEmailDocumentContinue(emailForm: any) {
        this.isFormLoading = true;
        this.commonService.SendEmailDocument(emailForm)
            .pipe(finalize(() => (this.isFormLoading = false)))
            .subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    this.toastr.success(response.errors);
                    const sendingData = {
                        confirmResult: true
                    };
                    this.dialogRef.close(sendingData);
                } else {
                    this.toastr.error(response.errors || CommonConstants.errorMessageConstants.errorMessageRetry, CommonConstants.appComponent.error);
                }
            });
    }

    toEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.toEmailValidationMessage);
    }

    ccEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.ccEmailValidationMessage);
    }

    bccEmailValidationMessage() {
        this.toastr.warning(CommonConstants.appComponent.bccEmailValidationMessage);
    }

    setAdditionalEmails(addIn, addFrom) {
        // additional for To email
        if (addFrom.toFromContact && addFrom.documentConfigData.shipFromEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.shipFromEmail}` : addFrom.documentConfigData.shipFromEmail;
        }
        if (addFrom.toToContact && addFrom.documentConfigData.shipToEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.shipToEmail}` : addFrom.documentConfigData.shipToEmail;
        }
        if (addFrom.toPayerContact && addFrom.documentConfigData.payerEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.payerEmail}` : addFrom.documentConfigData.payerEmail;
        }
        if (addFrom.toIntermediaryContact && addFrom.documentConfigData.intermediateEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.intermediateEmail}` : addFrom.documentConfigData.intermediateEmail;
        }
        // additional for to myself email
        if (addFrom.emailForm.toMyself && addFrom.documentConfigData.meEmail) {
            addIn.to += (addIn.to) ? `;${addFrom.documentConfigData.meEmail}` : addFrom.documentConfigData.meEmail;
        }
        // additional for Cc email
        if (addFrom.ccFromContact && addFrom.documentConfigData.shipFromEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.shipFromEmail}` : addFrom.documentConfigData.shipFromEmail;
        }
        if (addFrom.ccToContact && addFrom.documentConfigData.shipToEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.shipToEmail}` : addFrom.documentConfigData.shipToEmail;
        }
        if (addFrom.ccPayerContact && addFrom.documentConfigData.payerEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.payerEmail}` : addFrom.documentConfigData.payerEmail;
        }
        if (addFrom.ccIntermediaryContact && addFrom.documentConfigData.intermediateEmail) {
            addIn.cc += (addIn.cc) ? `;${addFrom.documentConfigData.intermediateEmail}` : addFrom.documentConfigData.intermediateEmail;
        }
        // additional for Bcc email
        if (addFrom.emailForm.bccToMyself && addFrom.documentConfigData.meEmail) {
            addIn.bcc += (addIn.bcc) ? `;${addFrom.documentConfigData.meEmail}` : addFrom.documentConfigData.meEmail;
        }
    }

    onClose(): void {
        this.dialogRef.close(false);
    }


}
